import { render } from "./PhoneVerificationModal.vue?vue&type=template&id=424dc917&scoped=true"
import script from "./PhoneVerificationModal.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationModal.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/AuthenticationModals/PhoneVerificationModal.css?vue&type=style&index=0&id=424dc917&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424dc917"]])

export default __exports__